/* eslint-disable @typescript-eslint/no-explicit-any */
import {IRequestInstance} from '@/types';
import {Form, FormInstance, UploadFile} from 'antd';
import React, {createContext, useState, ReactNode} from 'react';

interface FileListContextType {
  fileListState: UploadFile<File>[];
  setFileListState: React.Dispatch<React.SetStateAction<UploadFile<File>[]>>;
  isOpenProcessing: boolean;
  setIsOpenProcessing: React.Dispatch<React.SetStateAction<boolean>>;
  progressPercent: number;
  setProgressPercent: React.Dispatch<React.SetStateAction<number>>;
  listFileError: any;
  form: FormInstance<IRequestInstance>;
  setListFileError: React.Dispatch<React.SetStateAction<any>>;
  isCurrentUsage: boolean;
  setIsCurrentUsage: React.Dispatch<React.SetStateAction<boolean>>;
}

const FileListContext = createContext<FileListContextType | undefined>(
  undefined,
);

interface FileListProviderProps {
  children: ReactNode;
}

export const FileListProvider: React.FC<FileListProviderProps> = ({
  children,
}) => {
  const [fileListState, setFileListState] = useState<UploadFile<File>[]>([]);
  const [isOpenProcessing, setIsOpenProcessing] = useState<boolean>(false);
  const [progressPercent, setProgressPercent] = useState<number>(0);
  const [listFileError, setListFileError] = useState<any>([]);
  const [isCurrentUsage, setIsCurrentUsage] = useState<boolean>(false);
  const [form] = Form.useForm<IRequestInstance>();

  return (
    <FileListContext.Provider
      value={{
        fileListState,
        setFileListState,
        isOpenProcessing,
        setIsOpenProcessing,
        progressPercent,
        setProgressPercent,
        listFileError,
        form,
        setListFileError,
        isCurrentUsage,
        setIsCurrentUsage,
      }}
    >
      {children}
    </FileListContext.Provider>
  );
};

export const useFileList = (): FileListContextType => {
  const context = React.useContext(FileListContext);
  if (!context) {
    throw new Error('useFileList must be used within a FileListProvider');
  }
  return context;
};
